import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { patchFeatures } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { openFeaturesModal } from "ContentActions";
import { fetchFeature } from "GeneralTabAction";
import { COMMON_FAIL_MESSAGE } from "Constants";
import FeatureIcon from "./feature-icon";

class AddNewFeature extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      featurelist: [],
      loading: false,
    };

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.renderFeaturesIcons = this.renderFeaturesIcons.bind(this);
    this.selectedFeature = this.selectedFeature.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  selectedFeature(params) {
    var featureList = _.reject(
      this.state.featurelist,
      (f) => f.bsClass === params.bsClass
    );
    this.setState({ ...this.state, featurelist: [...featureList, params] });
  }

  renderFeaturesIcons() {
    //debugger;
    if (this.props.availableFeatures.length === 0) return <div />;
    var sFeatures = _.map(this.props.selectedFeatures, (f) => f.bsClass);
    var features = _.map(this.props.availableFeatures, (f) => {
      return { ...f, selected: sFeatures.indexOf(f.bsClass) !== -1 };
    });
    return _.map(features, (feature) => {
      return (
        <FeatureIcon
          key={feature.bsClass}
          feature={feature}
          smallIcons={true}
          callback={this.selectedFeature}
        />
      );
    });
  }

  onClickSave() {
    var finalList = [];
    var sFeatures = _.map(this.props.selectedFeatures, (f) => f.bsClass);
    var lFeatures = _.map(this.state.featurelist, (f) => f.bsClass);

    var selectedNotInLocal = _.filter(this.props.selectedFeatures, (f) => {
      if (lFeatures.indexOf(f.bsClass) == -1) {
        return f;
      }
    });

    var updatedInLocal = _.map(
      _.filter(this.state.featurelist, (f1) => {
        return f1.selected;
      }),
      (f) => ({
        label: f.iconName,
        bsClass: f.bsClass,
      })
    );

    var finalList = _.concat(selectedNotInLocal, updatedInLocal);

    if (finalList.length === 0) {
      this.props.showError("Select at least one feature");
    } else {
      this.props.patchFeatures(
        this.props.session,
        {
          newFeatures: _.concat(selectedNotInLocal, updatedInLocal),
        },
        true,
        (response) => {
          this.props.showSuccess("List is updated successfully");
          this.setState({ ...this.state, loading: false });
          this.props.fetchFeature(this.props.session);
          this.close();
        },
        (error) => {
          this.props.showError(COMMON_FAIL_MESSAGE);
          this.setState({ ...this.state, loading: false });
          this.close();
        }
      );
    }
  }

  close = () => {
    this.props.openFeaturesModal(false);
  };

  open = () => {
    this.props.openFeaturesModal(true);
    //this.setState({...this.state, showModal:true, featurelist: []});
  };

  render() {
    return (
      <div>
        {/*<div onClick={this.open}>Add New Feature</div>*/}
        <Modal
          className="modal-container"
          show={this.props.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
        >
          <Modal.Header>
            <h2 className="horizontal-align-center features-modal-desc">
              Choose the features that you would like to see on your event app
            </h2>
            <button
              type="button"
              className="close btn-sm btn-close "
              onClick={() => this.close()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-md-12">&nbsp;</div>
            </div>
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-10 features-icons-set">
                {this.renderFeaturesIcons()}
              </div>
              <div className="col-md-1" />
            </div>
            <div className="row">
              <div className="col-md-12">&nbsp;</div>
            </div>
            <div className="row">
              <div className="col-md-12 horizontal-align-center features-dark-color">
                You can always change this later
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              loading={this.state.loading}
              className="btn btn-default btn-primary"
              onClick={this.onClickSave}
            >
              Save & Continue
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.featuresModal,
    selectedFeatures: state.selectedFeatures,
    availableFeatures: state.availableFeatures,
  };
}

export default connect(mapStateToProps, {
  patchFeatures,
  showError,
  showSuccess,
  openFeaturesModal,
  fetchFeature,
})(AddNewFeature);
